import React from "react";
import Navbar from "../components/home/Navbar";
import Hero from "../components/home/Hero";
import Arrivals from "../components/home/Arrivals";
import AboutUs from "../components/home/AboutUs";
import BestSelling from "../components/home/BestSelling";
import QualityAssured from "../components/home/QualityAssured";
import Ordering from "../components/home/Ordering";
import HowItWorks from "../components/home/Steps";
import Delivery from "../components/home/Delivery";
import ContactUs from "../components/home/ContactUs";
import Footer2 from "../components/home/Footer2";
import "../components/home/landing.css";

export default function Home() {
  return (
    <div className="tfm-page">
      <Navbar />
      <main>
        <Hero />
        <Arrivals />
        <AboutUs />
        <BestSelling />
        <QualityAssured />
        <Ordering />
        <HowItWorks />
        <Delivery />
        <ContactUs />
      </main>
      <Footer2 />
    </div>
  );
}
